export default __webpack_public_path__ + "static/media/IconCross.9b032423.svg";